/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fixMissingInstrumentLink} from '../api'

export const useMutationFixMissingInstrumentLink = createReactQueryMutationHook('fixMissingInstrumentLink', fixMissingInstrumentLink)
